<template>
  <div class="card card-2">
    <div class="card-heading">
      <div class="account-erstellen">{{ $t("create_account") }}</div>

      <div class="registration-detail">{{ $t("register_14_days_free") }}</div>
      <div class="img-box">
        <img src="@/assets/images/Logo.png" class="img-responsive" alt="img" />
      </div>
    </div>
    <div class="card-body">
      <form @submit.prevent="loginFrom()" enctype="multipart/form-data" class="form-border-none">
        <div class="row">
          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("first_name") }} *</label>
            <div class="input-group">
              <input
                v-model="firstname"
                @blur="$v.firstname.$touch()"
                :class="{ 'is-invalid': submitted && $v.firstname.$error }"
                class="input--style-2 form-control"
                type="text"
                placeholder="Max"
              />
              <div
                v-if="submitted && $v.firstname.$error"
                class="invalid-feedback"
              >{{ $t('first_name') }} {{ $t('is_required') }}</div>
            </div>
          </div>

          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("last_name") }} *</label>
            <div class="input-group">
              <input
                v-model="lastname"
                @blur="$v.lastname.$touch()"
                :class="{ 'is-invalid': submitted && $v.lastname.$error }"
                class="input--style-2 form-control"
                type="text"
                placeholder="Mustermann"
              />
              <div
                v-if="submitted && $v.firstname.$error"
                class="invalid-feedback"
              >{{ $t('last_name') }} {{ $t('is_required') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("company") }} *</label>
            <div class="input-group">
              <input
                v-model="company"
                @blur="$v.company.$touch()"
                :class="{ 'is-invalid': submitted && $v.company.$error }"
                class="input--style-2 form-control"
                type="text"
                placeholder="Mustermann GmbH"
              />
              <div
                v-if="submitted && $v.company.$error"
                class="invalid-feedback"
              >{{ $t('company') }} {{ $t('is_required') }}</div>
            </div>
          </div>

          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("phone") }} </label>
            <div class="input-group">
              <input
                v-model="telefon"
                @blur="$v.telefon.$touch()"
                :class="{ 'is-invalid': submitted && $v.telefon.$error }"
                class="input--style-2 form-control"
                type="text"
                placeholder="0152345675454"
              />
              <!--<div
                v-if="submitted && !$v.telefon.$required && $v.telefon.numeric"
                class="invalid-feedback"
              >{{ $t('phone') }} {{ $t('is_required') }}</div>-->
              <div
                v-if="submitted && $v.telefon.$error && !$v.telefon.numeric"
                class="invalid-feedback"
              >{{ $t('phone') }} {{ $t('must_be_a_number') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("email") }} {{ $t("address") }} *</label>
            <div class="input-group">
              <input
                v-model="email"
                @blur="$v.email.$touch()"
                :class="{ 'is-invalid': submitted && $v.email.$error }"
                class="input--style-2 form-control"
                type="email"
                placeholder="Max.mustermann@web.de"
              />
              <div
                v-if="submitted && $v.email.$error"
                class="invalid-feedback"
              >{{ $t('email') }} {{ $t('is_required') }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("passwordp") }} *</label>
            <div class="input-group">
              <input
                v-model="password"
                @blur="$v.password.$touch()"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
                class="input--style-2 form-control"
                type="password"
                placeholder="*******"
              />
              <div v-if="submitted && !$v.password.required"
                   class="invalid-feedback">{{ $t('passwordp') }} {{ $t('is_required') }}</div>
              <div
                v-if="submitted && $v.password.$error && $v.password.required"
                class="invalid-feedback"
              >{{ $t('password') }} {{ $t('must_be_at_least') }} {{$v.password.$params.minLen.min}} {{ $t('characters') }}</div>
            </div>
          </div>

          <div class="overflow-hidden col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <label class="form-label">{{ $t("repeat_password") }} *</label>
            <div class="input-group">
              <input
                v-model="password_repeat"
                @blur="$v.password_repeat.$touch()"
                :class="{ 'is-invalid': submitted && $v.password_repeat.$error }"
                class="input--style-2 form-control"
                type="password"
                placeholder="*****"
              />
              <div
                v-if="submitted && $v.password_repeat.$error  && !$v.password_repeat.required && !$v.password.$error"
                class="invalid-feedback"
              >{{ $t('password') }} {{ $t('not_matched') }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="custom-control custom-checkbox mb-3 custom-check">
            <input
              v-model="emailinfo"
              @blur="$v.emailinfo.$touch()"
              :class="{ 'is-invalid': submitted && $v.emailinfo.$error }"
              class="custom-control-input form-control"
              type="checkbox"
              id="customCheck"
            />
            <label class="custom-control-label" for="customCheck">
              {{ $t("agree_to_receive_email") }}
              <a href="#">{{ $t("syste_relevent_notification") }}</a>
              {{ $t("by_email") }} *
            </label>
          </div>
        </div>

        <div class="row">
          <div class="custom-control custom-checkbox mb-3 custom-check">
            <input
              v-model="tngs"
              @blur="$v.tngs.$touch()"
              :class="{ 'is-invalid': submitted && $v.tngs.$error }"
              class="custom-control-input form-control"
              type="checkbox"
              id="customCheck1"
            />
            <label class="custom-control-label" for="customCheck1">
              {{ $t("agree_to_terms_and_conditions") }}
              <a href="#">{{ $t("terms_and_conditions") }}</a>
              {{ $t("and") }}
              <a href="#">{{ $t("privacy_policy") }}</a> {{$t('zu')}}*
            </label>
          </div>
        </div>
        <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12" >
        <div  :class="{ 'boxdiv': submitted && $v.captchatoken.$error }">
          <vue-recaptcha
            @verify="markRecaptchaAsVerified"
            sitekey="6Le-wvkSAAAAAPBMRTvw0Q4Muexq9bi0DJwx_mJ-"
          ></vue-recaptcha>
        </div>
        </div>
        <div class="p-t-30">
          <button class="btn btn--radius btn--green" type="submit">{{ $t("register") }}</button>
          <span class="al-login">
            {{ $t("or") }}
            <a href="/login">{{ $t("log_in") }}</a>
          </span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'

import {
  required,
  email,
  minLength,
  sameAs,
  numeric
} from 'vuelidate/lib/validators'
export default {
  name: 'login',
  data () {
    return {
      firstname: '',
      lastname: '',
      company: '',
      telefon: '',
      password: '',
      emailinfo: '',
      email: '',
      tngs: '',
      password_repeat: '',
      captchatoken: '',
      is_error: false,
      msg: '',
      isSave: false,
      submitted: '',
      check: false
    }
  },
  validations: {
    firstname: { required },
    lastname: { required },
    company: { required },
    telefon: { numeric },
    emailinfo: { required },
    tngs: { required },
    password: { required, minLen: minLength(6) },
    password_repeat: { sameAs: sameAs('password') },
    captchatoken: { required },
    email: { required, email }
  },
  methods: {
    markRecaptchaAsVerified (response) {
      this.captchatoken = response
    },
    loginFrom () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      axios
        .post(process.env.VUE_APP_BASE_URL + `register`,
          {
            firstname: this.firstname,
            lastname: this.lastname,
            company: this.company,
            telefon: this.telefon,
            password: this.password,
            emailinfo: this.emailinfo,
            tngs: this.tngs,
            email: this.email,
            password_repeat: this.password_repeat,
            captchatoken: this.captchatoken
          },
          {
            headers: {
              'Content-Type': 'text/plain',
              Cookie: 'PHPSESSID=jkaskfjhakjfhdkjfhaksdj'
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.msg = ''
            this.msg = response.data.status
            this.$router.push('/RegisterMs')
          } else {
            this.msg = response.statusText
          }
        })
        .catch(e => {
          this.msg = e
        })
    }
  },
  computed: {
    isDisabled: function () {
      return this.check
    }
  },
  components: { VueRecaptcha },

  created () {}
}
</script>
<style scoped >

</style>



// WEBPACK FOOTER //
// src/components/login/Register.vue